/**
 * Supabase Client
 * 
 * Frontend Supabase client for authentication.
 * Uses anon key (safe for frontend).
 * Deploy: 2026-06-13 auth lock fix
 */

import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
    console.warn(
        '[Supabase] Missing environment variables. Check VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env.local'
    );
}

export const supabase = createClient(
    supabaseUrl || '',
    supabaseAnonKey || '',
    {
        auth: {
            // Bypass navigator.locks which causes "AbortError: signal is aborted without reason"
            // in supabase-js v2.100+ when concurrent auth operations collide.
            // Safe for single-tab apps like ours.
            lock: async (_name, _acquireTimeout, fn) => fn(),
        },
    }
);
